module.exports = __webpack_public_path__ + "img/SVK.74c1e6dd.png";